import React, { useEffect, createElement } from 'react';
export const PaystackScript: React.FC = () => {
  useEffect(() => {
    // Check if script is already loaded
    if (!document.querySelector('script[src="https://js.paystack.co/v1/inline.js"]')) {
      const script = document.createElement('script');
      script.src = 'https://js.paystack.co/v1/inline.js';
      script.async = true;
      document.head.appendChild(script);
      return () => {
        // Cleanup if component unmounts
        document.head.removeChild(script);
      };
    }
  }, []);
  return null;
};